import { Formik } from 'formik';
import CustomisedButton from '../../../components/button/button';
import CustomisedCardUpload from '../../../components/card/cardUpload';
import IdentityInformationSkeleton from './identityInformationSkeleton';
import { IResidenceRequest } from '../../../models/residence.model';
import { useEffect, useRef, useState } from 'react';
import CustomisedCardLoad from '../../../components/card/cardLoad';
import { IUploadFile } from '../../../components/uploader/IUploadFile';
import { useMutation } from 'react-query';
import {
    GetDocumentByLoanRequest,
    GetRequiredDocuments,
    RegisterDocument,
    RemoveDocument,
} from '../../../services/identity.service';
import {
    IDocumentRequest,
    IDocumentResponse,
    IGetDocumentsResponse,
    IRegisterDocumentRequest,
    IRemoveDocumentResponse,
} from '../../../models/identity.model';
import { ApiResultModel, IReferenceKey } from '../../../models/common.model';
import { getFormRejectReasons } from '../../../services/registration.service';
import { IGetFormRejectReasonsResponse } from '../../../models/registration.model';
import { Button, Grid } from '@mui/material';
import CustomisedErrorCard from '../../../components/card/errorCard';
import { IFormInnerState } from '../form/IFormInnerState';
import { useDispatch } from 'react-redux';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { DOCUMENT_TYPES } from '../../../config/cacheKey';
import { IDocumentTypeHints } from '../../../models/basicInformation.model';
import { setHeaderTitle } from '../../../redux/headerTitle/headerTitleSlice';
import { useAppBar } from '../../../components/appBar/appBarContext';

const IdentityInformation = ({ setFormInnerState, setStep, referenceKey }: IFormInnerState) => {
    let initialValues = {} as IResidenceRequest;
    const [file, setFile] = useState<IUploadFile>();
    const [data, setData] = useState<IDocumentResponse[]>();
    const [fileArray, setFileArray] = useState<IDocumentResponse[]>([]);
    const [array, setArray] = useState<IDocumentResponse[]>(fileArray);
    const [delImage, setDelImage] = useState<boolean>(false);
    const [arrayList, setArrayList] = useState<IGetDocumentsResponse[]>([]);
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [documentType, setDocumentType] = useState<string[]>([]);
    const [getDocumentTypeService, setGetDocumentTypeService] = useState<string[]>([]);
    const [checkBySetad, setCheckBySetad] = useState(false);
    const buttonRef = useRef<any>(null)
    const { setHeader } = useAppBar();
    let refrenceKeyRequest = {} as IReferenceKey;
    refrenceKeyRequest.referenceKey = referenceKey!;
    const setChildValue = (childValues: any) => {
        let newArray = fileArray?.filter(
            (item: any) => item.fileUrl !== childValues?.fileUrl!
        );
        setFileArray(newArray);
    };
    let identityArray: any = [];
    const randomKeyForDispatch = Math.random();
    useEffect(() => {
        const registerDocument = {} as IRegisterDocumentRequest;
        fileArray.map((item: any) =>
            item.documentTypeTitle === file?.title
                ? ((item.fileUrl = file?.fileUrl),
                    (registerDocument.data = file?.file!),
                    (registerDocument.base64Date = file?.fileUrl),
                    (registerDocument.referenceKey =
                        refrenceKeyRequest.referenceKey),
                    (registerDocument.documentType = item.documentType),
                    RegisterDocumentMutate(registerDocument))
                : ''
        );

        setArray([]);
    }, [file]);

    useEffect(() => {
        load();
    }, [data]);
    const dispatch = useDispatch();

    useEffect(() => {
        setGetDocumentTypeService(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!));
        GetDocumentByLoanRequestMutate(refrenceKeyRequest);
        GetRequiredDocumentsMutate(refrenceKeyRequest);
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Identity'
        });

        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
        // dispatch(
        //     setHeaderTitle({
        //         header: 'اطلاعات هویتی',
        //         parentRoute: 'identity',
        //     })
        // );
        setHeader('اطلاعات هویتی', 'identityInformation');

    }, []);
    useEffect(() => {
        GetDocumentByLoanRequestMutate(refrenceKeyRequest);
        setDelImage(false);
    }, [delImage]);



    const { mutate: GetDocumentByLoanRequestMutate, isLoading } = useMutation(
        GetDocumentByLoanRequest,
        {
            onSuccess: (data: IDocumentResponse[]) => {
                if (data) {
                    setData(data);
                }
            },
            onError: () => {
                load();
            },
        }
    );
    const { mutateAsync: RegisterDocumentMutate } = useMutation(RegisterDocument, {
        onSuccess: (data: ApiResultModel<IDocumentResponse>) => {
            if (data.isSuccess) {
                if (data.data) {
                    fileArray?.map((item: any) =>
                        item.documentType === data.data.documentType ?
                            (
                                item.fileId = data.data.fileId,
                                item.fileUrl = data.data.fileUrl,
                                item.fileType = data.data.fileType
                            )
                            : ''

                    )
                    GetRejectReasonsResidenceMutate({
                        referenceKey: referenceKey!,
                        form: 'Identity'
                    });
                }
            }
            else {
                fileArray?.map((item: any) =>
                    item.fileId === undefined ?
                        (
                            item.fileId = null,
                            item.fileUrl = null
                        )
                        : ''

                )
                GetRejectReasonsResidenceMutate({
                    referenceKey: referenceKey!,
                    form: 'Identity'
                });

            }

        },
        onError: (e: any) => {
        },
    });
    const { mutate: GetRequiredDocumentsMutate } = useMutation(
        GetRequiredDocuments,
        {
            onSuccess: (data: IGetDocumentsResponse[]) => {
                if (data) {
                    setArrayList(data)
                }
            },
            onError: () => { },
        }
    );
    let val: any = {} as IDocumentTypeHints;
    const load = () => {
        arrayList?.map((item: any) => {
            let findData = data?.find(
                (x: any) => x.documentType === item.enumName
            );
            if (findData !== undefined) {
                identityArray.push(findData);
            } else {
                const document = {} as IDocumentResponse;
                document.documentType = item.enumName;
                document.documentTypeTitle = item.title;
                document.comment = item.comment;
                document.fileUrl = '';
                identityArray.push(document);
            }
        });
        identityArray?.map((item: any) => {
            val = getDocumentTypeService?.find((x: any) =>
                x.documentType === item.documentType
            )
            if (val) {
                item.fileExtensions = (val.fileExtensions);
                item.hints = val.hints;
                item.maxSizeKb = val.maxSizeKb;
            }
        }
        )
        setFileArray(identityArray);
    };

    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                let arrRejectReasons: string[] = [];
                let arrDocumentType: string[] = [];
                data[0]?.documentTypeRejectReasons?.map((value: any) => {
                    arrDocumentType.push(value.documentType);
                    value.rejectReasons?.map((item: any) => {
                        arrRejectReasons.push(item)
                    })
                }
                )
                setDocumentType(arrDocumentType);
                setRejectReasons(arrRejectReasons);
                setCheckBySetad(true);
            },
        }
    );
    const handleContinue = () => {
        setFormInnerState!('formList');
    }

    if (isLoading) {
        return <IdentityInformationSkeleton />
    } else {
        return (
            <div className="container-height-drawer">
                <div className="content-container">
                    <div className='drawer-content'>
                        <Formik initialValues={initialValues} onSubmit={() => { }}>
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleBlur,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div className="centerClass" style={{ width: '98%' }}>
                                        <Grid
                                            container
                                            className="row"
                                            spacing={2}
                                            style={{
                                                alignItems: 'center',
                                                width: '98%',
                                                margin: 'auto',
                                            }}
                                        >
                                            {rejectReasons.length > 0 ? <Grid
                                                item
                                                className="row pb-5"
                                                spacing={2}
                                                style={{
                                                    paddingLeft: '0px',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    margin: 'auto',
                                                }}
                                            >
                                                <CustomisedErrorCard titleList={rejectReasons} />
                                            </Grid> : null

                                            }
                                            {fileArray.map((item: any) =>
                                                item.fileUrl === null ||
                                                    item.fileUrl === undefined ||
                                                    item.fileUrl === '' ? (
                                                    <Grid item xs={12} style={{ paddingLeft: '0px' }}>
                                                        <CustomisedCardUpload
                                                            title={item.documentTypeTitle}
                                                            comment={item?.hints?.length > 100 ? item.hinte.slice(0, 100) + '...' : item?.hints}
                                                            setFileSelected={setFile}
                                                            fileExtensions={item.fileExtensions}
                                                            maxSizeKb={item.maxSizeKb}
                                                            rejected={documentType.length > 0 ? (documentType.filter((val) =>
                                                                val === item.documentType
                                                            )).length > 0 ? true : false : undefined
                                                            }
                                                            checkBySetad={checkBySetad}
                                                            fileType={item?.fileType}
                                                        />
                                                    </Grid>

                                                ) : (
                                                    <><Grid item xs={12} style={{ paddingLeft: '0px' }}>
                                                        <CustomisedCardLoad
                                                            comment={item?.hints?.length > 100 ? item.hinte.slice(0, 100) + '...' : item?.hints}
                                                            title={item.documentTypeTitle}
                                                            fileSelected={item.fileUrl}
                                                            documentId={item.fileId}
                                                            serviceName={RemoveDocument}
                                                            serviceRequestObj={
                                                                {
                                                                    referenceKey:
                                                                        refrenceKeyRequest.referenceKey,
                                                                    documentId: item.fileId,
                                                                } as IDocumentRequest
                                                            }
                                                            setDelImage={setDelImage}
                                                            setChildValue={setChildValue}
                                                            rejected={documentType.length > 0 ? (documentType.filter((val) =>
                                                                val === item.documentType
                                                            )).length > 0 ? true : false : undefined
                                                            }
                                                            checkBySetad={checkBySetad}
                                                            fileType={item.fileType}
                                                        />
                                                    </Grid>
                                                    </>
                                                )
                                            )}
                                        </Grid>
                                        <div className="pt-5 button-container">
                                            <Button
                                                // title={'ادامه'}
                                                // disable={false}
                                                onClick={handleContinue}
                                                type="submit"
                                                ref={buttonRef}
                                                style={{ display: "none" }}
                                            ></Button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click()
                                }

                            }}
                            title='ادامه'
                            type='button'
                            disable={arrayList.length === (fileArray.filter((item: any) => item.fileUrl !== "")).length ? false : true}

                        />

                    </div>
                </div>
            </div>
        );
    }
};

export default IdentityInformation;

function uuid(): any {
    throw new Error('Function not implemented.');
}
